import { clickHandler } from '../plugins/clickHandler';

export const replaceLinkClickPlugin = (
  emitter: any,
  plugins: any[],
  editor: any,
  type: any,
  openOnClick: boolean
) => {
  const index = plugins.findIndex((plugin) => {
    // @ts-ignore
    const key = plugin.spec.key.key || '';
    return key.startsWith('handleClickLink');
  });

  if (index) {
    plugins.splice(index, 1);
  }

  const newPlugins = [];
  newPlugins.push(...plugins);

  if (openOnClick) {
    newPlugins.push(
      clickHandler({
        type,
        emitter,
        editor,
      })
    );
  }

  return newPlugins;
};
